import { PettyCashCreatePage } from "@/features/petty-cash/pages/PettyCashCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/petty-cash/expense/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["petty_cash.create_expense"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: () => <PettyCashCreatePage type="expense"/>
});
